<script>
    import Button from "$lib/Button.svelte";
</script>

<Button color="teal" on:click {...$$restProps}>
    <slot></slot>
</Button>
